<template>
  <div class="digital-upload-image">
    <!--    :id="'digitalUploadImage' + classifyManage"-->
    <Uploader
      ref="uploader"
      id="digitalUploadImage"
      :dropzoneOptions="digitalUploadWordOptions"
      @uploadProgress="uploadProgress"
      @addFile="addFile"
      @uploadSuccess="uploadSuccess"
      @uploadError="uploadError"
      @canceled="uploadCanceled"
      @uploadComplete="uploadComplete"
      @uploadSending="uploadSending"
    >
    </Uploader>
  </div>
</template>

<script>
import apis from '@api/login'
import Uploader from '@components/common/Uploader'
import { isIllegalWord, getBrowser } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'DigitalUploadWord',
  data() {
    return {
      // classifyManage: ''
    }
  },
  props: {
    classifyManage: {
      type: String,
      default: ''
    },
    fileSize: {
      type: Number,
      default: 10
    }
  },
  computed: {
    ...mapState('book'),
    digitalUploadWordOptions: {
      get() {
        const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
        let options = {
          url: uploadBaseUrl + '/ebook/wordArticle/uploadExtractArticle',
          thumbnailWidth: 150,
          headers: { Accept: 'application/json, text/plain, */*' },
          autoProcessQueue: false,
          chunking: true,
          chunkSize: 1024 * 1024,
          forceChunking: true,
          acceptedFiles: '.doc,.docx',
          duplicateCheck: true,
          timeout: 10000000000000000
        }
        return options
      }
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    upload() {
      const browser = getBrowser()
      if (browser === 'QQ浏览器' || browser === 'Safari') {
        //qq浏览器 safari
        if (this.userName) {
          // $('#digitalUploadImage').click()
          this.$refs.uploader.$el.click()
        } else {
          this.login()
        }
      } else {
        this.login()
      }
    },
    login() {
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            window.location.href = data.data
          } else {
            //QQ浏览器内不生效
            document.querySelector('#digitalUploadImage').click()
          }
        }
      })
    },
    addFile(file) {
      if (!isIllegalWord(file.name)) {
        this.$nextTick(() => {
          this.$refs.uploader.processQueue()
          this.$emit('updateWordState', 'start')
        })
      } else {
        this.$refs.uploader.cancelUpload()
        this.$alert('文件名中含有特殊字符，请重新上传', '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    uploadSending(file, xhr, formData) {
      formData.append('fileName', file.name)
      if (this.classifyManage) {
        formData.append('classifyManage', this.classifyManage)
      }
      // formData.append('dzuuid', file.upload.uuid)
      const currentIndex = Number.parseInt(formData.get('dzchunkindex')) + 1
      const total = Number.parseInt(formData.get('dztotalchunkcount'))
      if (currentIndex === total) {
        this.$emit('updateWordState', 'sended')
      }
    },
    uploadSuccess(file) {
      if (file.xhr.response) {
        let res = JSON.parse(file.xhr.response)
        if (res.data) {
          this.$emit('updateWordProgress', 100)
          this.$emit('updateWordSuccess', res, file)
        } else {
          this.$alert(res.message || '接口请求失败', '提示', {
            confirmButtonText: '确定',
            callback: (action) => {
              if (action === 'confirm') {
                this.$refs.uploader.cancelUpload()
                this.$nextTick(() => {
                  this.uploadCanceled()
                })
              }
            }
          })
        }
      }
    },
    uploadComplete(file) {
      this.$emit('updateWordComplete', file)
    },
    uploadError(file, message, xhr) {
      if (!this.fileSize && message.startsWith('File is too big')) {
        this.$alert(`上传文件最大不能超过10M`, '提示', {
          confirmButtonText: '确定'
        })
      } else if (message.startsWith("You can't upload files of this type")) {
        this.$alert('请上传doc|docx文件', '提示', {
          confirmButtonText: '确定'
        })
      } else if (message !== 'Upload canceled.') {
        this.$alert('您的作品内容较多，不能短时间内完成转换，请耐心等待，保存后稍后刷新查看', '提示', {
          confirmButtonText: '确定'
        })
      }
      this.$nextTick(() => {
        this.uploadCanceled()
      })
      this.$emit('updateWordError', file, message)
    },
    uploadProgress(file, progress, bytesSent) {
      const percentage = Number(((bytesSent / file.size) * 100).toFixed(2))
      this.$emit('updateWordProgress', percentage)
    },
    uploadCanceled(file) {
      this.$emit('updateWordState', 'canceled')
    },
    cancelRestore() {
      this.$refs.uploader.cancelUpload()
      this.$nextTick(() => {
        this.uploadCanceled()
      })
    }
  },
  components: {
    Uploader
  }
}
</script>

<style lang="scss" scoped>
.vue-dropzone {
  height: 100%;
  width: 100%;
  min-height: 40px !important;
  border: 0;
  padding: 0;
  position: absolute;
  &:hover {
    background: #fff;
  }
  .dz-message {
    margin: 0;
  }
}
</style>
